<template>
  <div class="custom-container" id="ticket-view"  v-if="ticketData.conversation">
    <b-container fluid class="my-4 custom-container">
      <b-row class="mb-3">
        <b-col cols="12">
          <PageHeader
            :title="ticketData.subject"
            :special-back-link="true"
            :enable-back-link="true"
            @goBack="returnToTickets"
          />
        </b-col>
      </b-row>
      <b-row v-for="message in ticketData.conversation.messages" :key="message.id">
        <div class="w-100">
          <b-card class="font-jumper" :class="message.from_field.username && message.from_field.username.includes('@acounto_user') ? 'message-card custom-hover-user-message' : 'message-card-acounto custom-hover-acounto-message'" @click="toggleExpand(message)">
            <div class="d-flex  justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center mr-3">
                  <i v-if="message.from_field.username.includes('@acounto_user')" class="far fa-user" style="font-size: 28px;"></i>
                  <img v-else :src="getImgUrl('user.svg')" />
                </div>
                <div class="d-flex flex-column justify-content-center mr-3">
                  <p class="mb-0" v-if="message.from_field.username.includes('@acounto_user')"><strong>{{ getActiveCompany.companyManager.lastName + " " + getActiveCompany.companyManager.firstName }}</strong></p>
                  <p class="mb-0" v-else><strong>Acounto Ügyfélszolgálat</strong></p>
                  <p class="mb-0" v-if="message.from_field.username.includes('@acounto_user')" style="font-size: 12px">{{getActiveCompany.companyManager.email}}</p>
                  <p class="mb-0" v-else style="font-size: 12px">acounto.com</p>
                </div>
              </div>
              <div class="d-flex align-items-top ">
                <p class="mb-0"><span class="text-muted small" :title="formatDate(message.delivered_at)">{{ formatRelativeDate(message.delivered_at) }}</span></p>
              </div>
            </div>
            <p class="message-box" :key="forceUpdateKey" v-html="getFormattedMessage(message)"/>
          </b-card>
        </div>
      </b-row>

       
        <div v-if="!textAreaOpened" class="text-right">
            <b-button
            v-if="!ticketData.isClosed"
            variant="primary"
            class="new-msg"
            @click="toggleTextArea"
            :disabled="!disableButtons"
            >
                Új üzenet
            </b-button> 
            <b-button
            v-if="!ticketData.isClosed"
            variant="secondary"
            class="close-button"
            @click="closeTicket"
            :disabled="!disableButtons"
            >
                Lezárás
            </b-button> 
        </div>  

          <div class="textarea-container" v-if="!ticketData.isClosed && textAreaOpened">
            <b-form-textarea
              v-model="newMessage"
              placeholder="Üzenet írása..."
              rows="5"
              auto-grow
            ></b-form-textarea>
            <b-button
              variant="primary"
              class="send-button"
              @click="sendMessage"
              :disabled="!disableButtons"
            >
              Küldés
            </b-button>
          </div>
          <div
              class="validation-error-msg"
              ref="message-validation-message"
          />
      
    </b-container>

  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import Api from "api-client";
import { mapGetters } from "vuex";
import Util from "@/utils/Util";
import moment from "moment";
import 'moment/locale/hu';

export default {
  name: "Ticket",
  components: {
    PageHeader,
  },
  data() {
    return {
      ticketData: {},
      forceUpdateKey: 0,
      newMessage: "",
      disableButtons: false,
      textAreaOpened: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  methods: {
    getData() {
      this.disableButtons = false
      Api.getTicket(this.$route.params.uuid, this.getActiveCompany.id)
        .then((resp) => {
          resp.data.conversation.messages.forEach(message => {
            if (message.from_field.username === null) {
              message.from_field.username = "@acounto_support";
            }
          });
          this.ticketData = resp.data;
          this.ticketData.conversation.messages.sort((a, b) => a.delivered_at - b.delivered_at);
          this.ticketData.conversation.messages.forEach((msg) => {
            msg.turnicated = true
          })
          this.disableButtons = true
        })
        .catch(() => {
          self.$toast.error({
            title: this.$cte("common.error"),
            message: this.$cte("tasks.failedGetTask"),
          });
        });  
    },
    returnToTickets() {
      this.$router.go(-1)
    },
    toggleExpand(message) {
      message.turnicated = !message.turnicated
      this.forceUpdateKey++;
    },
    getMessage(message) {
      return message.body.length > 200 && message.turnicated ? message.body.substring(0, 200) + '...' : message.body;
    },
    getFormattedMessage(message) {
      const body = this.getMessage(message);
      return body.replace(/\n/g, '<br>');
    },
    formatDate(timestamp) {
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return `${year}.${month}.${day} ${hours}:${minutes}`;
    },
    formatRelativeDate(timestamp){
      const date = new Date(timestamp * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2);
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      return moment(`${year}.${month}.${day} ${hours}:${minutes}`).fromNow();
    },
    sendMessage() {
      this.disableButtons = false
      return Api.sendMessage(this.ticketData.uuid, this.newMessage ,this.getActiveCompany.id).then(() => {

          this.newMessage = ""
          this.getData()
          this.$toast.success({
            title: "Sikeres üzenetküldés!",
            message: "Kollégáink hamarosan válaszolnak!",
          });
          Util.clearValidationErrors(
            document.getElementById("ticket-view")
          );

          this.disableButtons = true;
          this.toggleTextArea();
        }).catch((err) => {
          this.$toast.error({
            title: "Sikertelen üzenetküldés!",
            message: "Kérünk próbáld meg újra!",
          });
          if (err.isAxiosError && err.response.data.failList) {
                setTimeout(() => {
                  Util.clearValidationErrors(
                    document.getElementById("ticket-view")
                  );
                  Util.showValidationErrors(err, this.$refs);
                }, 100);
          }
          this.disableButtons = true;
        });
    },
    closeTicket() {
      this.disableButtons = false
      return Api.closeTicket(this.ticketData.uuid, this.getActiveCompany.id).then(() => {
        this.disableButtons = true;
        this.newMessage = ""
        this.getData()
        this.$toast.success({
          title: "Sikeres lezárás!",
          message: "Sikeres lezárás!",
        });
      }).catch(() => {
        this.$toast.error({
          title: "Sikertelen lezárás!",
          message: "Kérünk próbáld meg újra!",
        });
        this.disableButtons = true;
      });
    },
    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },
    toggleTextArea() {
      this.textAreaOpened = !this.textAreaOpened;
    },
  },
  created() {
    this.getData();
  }
};
</script>

<style scoped>
@media (min-width: 768px) {
  .bottom-buttons .first {
    float: left;
  }

  .bottom-buttons .second {
    margin: 0 auto;
  }

  .bottom-buttons .third {
    float: right;
  }
}

.bottom-buttons .btn {
  width: 125px !important;
}

.bottom-buttons > div > div {
  margin: 0 auto;
}

.max-content {
  width: max-content;
}

.bottom-buttons .btn {
  color: white;
}

.custom-thumbnail {
  cursor: pointer;
  max-width: 128px;
  max-height: 128px;
  height: 128px;
  min-width: 72px;
  background-color: #eee;
  border-radius: 5px;
  position: relative;
  border: 1px solid gray;
}

.custom-image-preview {
  max-height: 128px;
  max-width: 128px;
  width: 100%;
  height: 100%;
}

.file-label-hack {
  position: absolute;
  bottom: -19px;
}

.file-text {
  display: block;
  width: 70px;
}

.custom-thumbnail-image {
  border-radius: 5px;
}

.nowrap {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.custom-file-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 30px;
  height: 45px;
}

.message-card {
  padding: 12px;
  width: 75%;
  margin-bottom: 30px;
}
.message-box {
  margin-top: 8px;
  margin-left: 0px;
}

.message-card-acounto {
  width: 70%;
  background-color: #b2ec5d !important;
  color: #252734 !important;
  float: right;
}

.card-body {
  padding-bottom: 0px !important;
  margin-bottom: 12px;
}

.textarea-container {
  position: relative;
  margin-bottom: 12px;

}

.textarea-container .send-button {
  position: absolute;
  bottom: 8px;
  right: 8px;
}

.close-button {
  width: 240px;
  text-align: center;
  background-color: #FFA800;
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 12px;
  margin-left: 12px;
}
.new-msg {
  width: 240px;
  text-align: center;
  color: #FFFFFF;
  font-size: 24px;
  margin-bottom: 12px;
}
.custom-container {
  margin-bottom: 30px;
}

</style>
